import React from 'react';
import { Link } from 'gatsby';
import { Link as ScrollLink } from 'react-scroll';

function HeaderLink({ type, text, target }) {
  if (type === 'anchor') {
    return <ScrollLink to={target}>{text}</ScrollLink>;
  }
  return (
    <Link to={target} activeStyle={{ color: 'gold' }}>
      {text}
    </Link>
  );
}

export default HeaderLink;
